import { render } from "./Analysis.vue?vue&type=template&id=486d8f2e&scoped=true"
import script from "./Analysis.vue?vue&type=script&lang=js"
export * from "./Analysis.vue?vue&type=script&lang=js"

import "./Analysis.vue?vue&type=style&index=0&id=486d8f2e&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486d8f2e"]])

export default __exports__